import { Subject, Car, SelectedCoverage } from "../objects/integrations/LexisPrefillModels";
import { Driver, Limit, Vehicle } from "../objects/policy";

export class LexisPrefillService {
    prefillApiUrl: string;

    constructor(){
        var baseApi = process.env.REACT_APP_BASE_API_URL;
        var prefillApi = process.env.REACT_APP_API_INTEGRATION_PREFILL ?? "";

        this.prefillApiUrl = baseApi + prefillApi;
    }

    async sendRequest(policyNum: string,
        firstName: string, 
        lastName: string, 
        address:string,
        city: string,
        state: string, 
        zip: string,
        effectiveDate: string) {
            var data = {
                policyNumber: policyNum,
                firstName: firstName,
                lastName: lastName,
                address: address,
                city: city,
                state: state,
                zip: zip,
                effectiveDate: effectiveDate
            };

            var jsonRequest = JSON.stringify(data);
            
            var response = await fetch(this.prefillApiUrl,
            {
                mode: "cors",
                method: "POST",
                headers: {
                    //"accept":"*/*",
                    "Access-Control-Allow-Origin": "*",
                    
                    //"Origin": "http://localhost:3000/",
                    //"Access-Control-Allow-Credentials": "true",
                    "Content-Type": "application/json",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                },
                body: jsonRequest
            })

            if(response.ok){
                return {
                    ok: true,
                    data: await response.json()
                }
            }else{
                return {
                    ok: false,
                    error: await response.json()
                }
            }
    }

    toDriversArray(currentDrivers: Driver[], subjects: Subject[]) : Driver[]{
        var drivers : Driver[] = [];

        var currentCount = currentDrivers.length + 1;
        for(const item of subjects){
            var foundDriver = currentDrivers.find(m=>(m.firstName?? "").toUpperCase() == (item.firstName ?? "").toUpperCase() && 
            (m.lastName ?? "").toUpperCase() === (item.lastName ?? "").toUpperCase());

            if(foundDriver) {
                if(item.licenseNumber !== "" && (foundDriver?.licenseNum ?? "") === ""){
                    var currentLicenseNumber = (foundDriver?.licenseNum ?? "");

                    console.log(`[prefill] Updating License#, current ${currentLicenseNumber}, prefill# ${item.licenseNumber}`);

                    foundDriver.licenseNum = currentLicenseNumber === "" ? item.licenseNumber : foundDriver.licenseNum;
                }

                if(item.licenseState !== "" && (foundDriver?.licenseState ?? "") === ""){
                    var currentLicenseState = (foundDriver?.licenseState ?? "");

                    console.log(`[prefill] Updating License State, current ${currentLicenseState}, prefill# ${item.licenseNumber}`);

                    foundDriver.licenseState = item.licenseState !== "" ? item.licenseState : foundDriver.licenseState;
                }
                continue;
            }

            var entity = new Driver();
            entity.driverNumber = currentCount;
            entity.firstName = item.firstName;
            entity.middleInitial = item.middleName;
            entity.lastName = item.lastName;
            entity.suffix = item.suffix;
            entity.dob = item.dateOfBirth !== "" && item.dateOfBirth !== undefined ?  new Date(item.dateOfBirth) : undefined;
            entity.licenseNum = item.licenseNumber;
            entity.licenseState = item.licenseState;
            entity.totalPoints = 0;
            entity.violationCount = 0;
            entity.isIncludeAtRenewal = false;
            entity.status = "RATED";
            entity.isExcluded = false;
            entity.gender = item.gender;
            entity.isMarried = item.maritalStatus === "MARRIED";
            entity.relation = "OTHER";
            
            
            // age: number = 0
            // licensedDate: string = ""
            // relation: string = ""
            // licenseStatus: string = ""
            // educationCode: string = ""
            // listOnlyOption: string = ""
            // occupationGroup: string = ""
            // occupationCode: string = ""
            // flags: Flag[] = []
            // violations: any[] = []

            drivers.push(entity);
            currentCount++;
        }

        return drivers;
    }

    toVehiclesArray(currentVehicles: Vehicle[], cars: Car[], selectedLimits:SelectedCoverage[]) : Vehicle[] {
        var vehicles : Vehicle[] = [];
        var currentCount = currentVehicles.length+1;
        for(const item of cars){
            if(currentVehicles.find(m=>(m.vin ?? "").toUpperCase() == (item.vin ?? "").toUpperCase())) {
                continue;
            }

            var limits = selectedLimits.filter(m=>m.key == item.vin );
            
            var entity = new Vehicle();
            entity.carNumber = currentCount;
            entity.vin = item.vin;
            entity.year = parseInt(item.year);
            entity.make = item.make ?? "";
            entity.isIncludeAtRenewal = false;
            entity.model = item.model ?? "";
            entity.bodyStyle = "";
            entity.annualMileage = parseInt(process.env.REACT_APP_DEFAULT_ANNUAL_MILEAGE ?? "8000");
            

            limits.map((v:SelectedCoverage, k:number)=>{
                var cov = new Limit();
                cov.limit = v.propertyValue;
                cov.name = v.propertyGroup;
                cov.type = v.propertyType;
    
                entity.coverageLimits.push(cov);
            });

            // costNew: number = 0.0
            // amountCustom: number = 0.0
            // annualMileage: number = 0
            // ownershipType: string = ""
            // statedAmount: number = 0
            // lengthOfOwnership: string = ""
            // aebCode: string = ""
            // blindSpotCode: string = ""
            // restraintCode: string = ""
            // Mileage: any
            // lienHolders: any
            // coverageLimits: any[] = []
            // flags: any
            // ratedOperator: any
        
            vehicles.push(entity);
            currentCount++;
        }
        return vehicles;
    }

    toLimitsArray(currentLimits: Limit[], integrationLimits: SelectedCoverage[]){
        var selectedLimits: Limit[] = [];
        
        for(const item of integrationLimits){
            if(selectedLimits.find(m=> m.name == item.propertyGroup && item.propertyValue == m.limit)){
                continue;
            }
            
            var entity = new Limit();
            entity.limit = item.propertyValue;
            entity.name = item.propertyGroup;
            entity.type = item.propertyType;

            selectedLimits.push(entity);
        }

        for(const item of currentLimits){
            if(selectedLimits.find(m=> m.name == item.name && item.limit == m.limit)){
                continue;
            }
            
            selectedLimits.push(item);
        }

        return selectedLimits;
    }
}